import commonModule from 'app/common';
import uiRouter from 'angular-ui-router';
import { LoginComponent } from './login/login.component.ts';
import {AuthCallbackComponent} from './auth-callback/auth-callback.component'
import { downgradeComponent } from '@angular/upgrade/static';
import { LicenseComponent } from "@app/authentication/license/license.component";

export default angular.module('authentication', [
    uiRouter,
    commonModule.name
])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state({
                name: 'app.auth',
                abstract: true,
                views: {
                    'main@app': {
                        template: require('./authentication.component.html')
                    }
                },
                params: {
                    redirectUri: ['$state', function ($state) {
                        return $state.href($state.current.name, $state.params);
                    }]
                },
                resolve: {
                    isAuthenticated: ['sessionService', '$state', '$timeout', function (sessionService, $state,$timeout) {
                        if (sessionService.user != null) {
                            $timeout (() => { $state.go("app.authorized.projects"); }, 0);
                            return true;
                        }
                    }]
                }
            })
            .state({
                name: 'app.auth.login',
                url: '/login',
                template: `<login></login>`,
                authentication : 'none'
            })
            .state({
                name: 'app.auth.authCallback',
                url: '/auth-callback',
                template: `<auth-callback></auth-callback>`,
                authentication : 'none'
            })
            .state({
                name: 'app.auth.licenseUpload',
                url: '/license',
                template: `<license></license>`,
                authentication : 'none'
            });
    }])
    .directive('login', downgradeComponent({ component: LoginComponent }))
    .directive('authCallback', downgradeComponent({ component: AuthCallbackComponent }))
    .directive('license', downgradeComponent({ component: LicenseComponent }));



// WEBPACK FOOTER //
// ./src/app/authentication/index.js